import Model from '@/core/models/Model';
import Qualification from '@/models/Qualification';
import type { Qualification as IQualification } from '@/types/Qualification';

class QualificationService {
  getQualifications() {
    return useAsyncData<IQualification[]>(
      'qualifications',
      async () => {
        return Model.processResponse(await Qualification.get()) as IQualification[];
      },
      { server: false }
    );
  }
}

const qualificationService = new QualificationService();
export default qualificationService;
